export const Gondal = {
    title: "Gondal",
    title1: "(Heritage & Royal City)",

    intro: "Gondal, a princely town in Gujarat, is known for its rich history, royal palaces, and heritage structures. Once the capital of the Gondal state, it boasts architectural marvels from the era of the Jadeja Rajputs and remains a significant cultural hub.",

    attractions: [
        {
            name: "Naulakha Palace",
            description: "Built in the 18th century, Naulakha Palace is the oldest and most magnificent palace in Gondal. It showcases intricate stone carvings, arches, and a collection of vintage furniture and artifacts used by the royal family. The palace also offers a glimpse into the opulent lifestyle of the erstwhile rulers.",
            location: "Gondal, Gujarat",
            timings: "9:00 AM to 12:00 PM & 3:00 PM to 6:00 PM",
            ticket: "₹30 per person",
            bestTimeToVisit: "October to March",
            activities: [
                "Explore the antique furniture and royal artifacts",
                "Admire the detailed carvings and architecture",
                "Visit the durbar hall and its impressive chandeliers",
                "Enjoy the scenic view of the Gondali River",
                "Learn about the royal history of Gondal"
            ],
            mapLink: "https://maps.app.goo.gl/6mRzTq4BxhDp1m3J9",
        },
        {
            name: "Orchard Palace",
            description: "A part of the Huzoor Palace estate, the Orchard Palace was once the guest house for royal visitors. It features a fusion of European and Indian architectural styles, lavish interiors, and a beautiful garden with fruit orchards.",
            location: "Gondal, Gujarat",
            timings: "9:00 AM to 12:00 PM & 3:00 PM to 6:00 PM",
            ticket: "₹50 per person",
            bestTimeToVisit: "November to February",
            activities: [
                "Stay in the heritage hotel section",
                "Explore the vintage royal car collection",
                "Walk through the lush gardens",
                "Admire the royal furniture and antique decor",
                "Learn about the history of the Jadeja rulers"
            ],
            mapLink: "https://maps.app.goo.gl/LuGZjKQ5wZ8rD7Nz7",
        },
        {
            name: "Swaminarayan Temple",
            description: "This temple, dedicated to Lord Swaminarayan, is a beautiful structure with intricate carvings and a peaceful atmosphere. It is a significant spiritual center in Gondal and attracts devotees from across Gujarat.",
            location: "Gondal, Gujarat",
            timings: "6:00 AM to 12:00 PM & 4:00 PM to 8:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Early morning or evening",
            activities: [
                "Seek blessings and participate in prayers",
                "Admire the temple's carvings and architecture",
                "Enjoy the peaceful surroundings",
                "Attend religious discourses",
                "Explore the nearby markets for religious souvenirs"
            ],
            mapLink: "https://maps.app.goo.gl/QTG2v2Tk8UmNn4Fw7",
        },
        {
            name: "Royal Vintage Car Collection",
            description: "A paradise for automobile enthusiasts, this museum displays an exquisite collection of vintage cars owned by the Maharajas of Gondal. It includes rare Rolls Royces, Bentleys, and other classic automobiles.",
            location: "Gondal, Gujarat",
            timings: "10:00 AM to 5:00 PM",
            ticket: "₹100 per person",
            bestTimeToVisit: "Throughout the year",
            activities: [
                "Witness vintage Rolls Royce, Bentley, and other classic cars",
                "Learn about the history of royal transportation",
                "Explore the garage where these cars are maintained",
                "Take guided tours to understand car restoration",
                "Capture photos of iconic luxury cars"
            ],
            mapLink: "https://maps.app.goo.gl/9D8aZLhQa4H8pNWe6",
        },
        {
            name: "Shri Bhuvaneshwari Temple",
            description: "A beautiful and spiritually significant temple dedicated to Goddess Bhuvaneshwari. The temple is known for its divine atmosphere and cultural significance in Gondal.",
            location: "Gondal, Gujarat",
            timings: "5:00 AM to 12:00 PM & 4:00 PM to 9:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "During Navratri or early morning",
            activities: [
                "Attend spiritual ceremonies and aarti",
                "Meditate in the peaceful surroundings",
                "Explore the temple’s artwork and idols",
                "Visit the ashram nearby",
                "Participate in religious events"
            ],
            mapLink: "https://maps.app.goo.gl/qG46yZomJsgwG1Pm7",
        },
        {
            name: "Gondal Market",
            description: "A bustling local market where visitors can experience the essence of Gondal’s culture. The market offers a variety of handicrafts, textiles, and local food items.",
            location: "Gondal, Gujarat",
            timings: "10:00 AM to 9:00 PM",
            ticket: "Free Entry",
            bestTimeToVisit: "Evening",
            activities: [
                "Shop for local handicrafts and textiles",
                "Taste authentic Gujarati street food",
                "Interact with local artisans",
                "Buy traditional jewelry and souvenirs",
                "Experience the lively atmosphere of a Gujarati bazaar"
            ],
            mapLink: "https://maps.app.goo.gl/Y7bZuQyp5X6C2JjQA",
        },
    ]
};
